import { AxiosInstance } from 'axios'

export interface PostToken {
  access_token: string;
  accessTokenExpires: string | number;
  error?: string;
  message?: string;
}

export default function GetToken(client: AxiosInstance) {
  async function getAccessToken() {
    try {
      // Call server-side token endpoint - no sensitive credentials exposed
      const { data } = await client.post<PostToken>('token', {})
      return {
        access_token: data?.access_token,
        accessTokenExpires: data?.accessTokenExpires,
        error: data?.error || '',
        message: data?.message || 'success',
      }
    } catch (err: any) {
      return {
        access_token: 'undefined',
        accessTokenExpires: '',
        error: err.response?.data?.error || err.message,
        message: 'failed to get token',
      }
    }
  }

  return {
    getAccessToken,
  }
}
